<script setup lang="ts">
import { watchDebounced } from '@vueuse/core'

import EpIconButton from '~/components/button/EpIconButton.vue'
import EpIcon from '~/components/icon/EpIcon.vue'

interface IProps {
  placeholder: string
  modelValue: string
}

const props = defineProps<IProps>()

const emits = defineEmits([ 'setResultShow', 'update:modelValue', 'enter' ])

const inputRef = ref<HTMLInputElement | null>(null)

const tempInput = ref('')

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  tempInput.value = target.value
}

const resetInput = () => {
  tempInput.value = ''
  emits('update:modelValue', '')
}

watchEffect(() => {
  if (!props.modelValue) {
    emits('setResultShow', false)
    tempInput.value = ''
  } else {
    emits('setResultShow', true)
  }
})

watchDebounced(tempInput, () => {
  emits('update:modelValue', tempInput.value)
}, { debounce: 500 })

onClickOutside(inputRef, () => {
  emits('setResultShow', false)
})
</script>

<template>
  <div class="search-bar-wrapper">
    <EpIcon
      name="search"
      :size="20"
      class="py-2 pl-2"
    />
    <input
      type="search"
      ref="inputRef"
      :placeholder="placeholder"
      class="search-input"
      @focus="emits('setResultShow', true)"
      :value="tempInput"
      @input="handleInput"
      @keydown.enter="emits('enter')"
    >
    <EpIconButton
      v-show="tempInput.length"
      icon-name="clear"
      :icon-size="20"
      class="clear-button"
      @click="resetInput"
    />
  </div>
</template>

<style scoped lang="scss">
.search-bar-wrapper {
  @apply flex items-center w-full gap-x-2;

  .search-input {
    @apply bg-transparent w-full pl-2;

    &:focus, &:focus-visible, &:active {
      @apply outline-0;
    }

    &::placeholder {
      @apply text-white/40;
    }

    &::-webkit-search-cancel-button {
      @apply appearance-none;
    }
  }

  .clear-button {
    @apply ml-auto shrink-0 cursor-pointer;
  }
}
</style>